import { render, staticRenderFns } from "./OverallLoader.vue?vue&type=template&id=1c8fc895&"
import script from "./OverallLoader.vue?vue&type=script&lang=js&"
export * from "./OverallLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports